const es = {
  slogan: `
    Empoderando a mujeres para que trabajen y prosperen en el mundo de la
    tecnología.
  `,
  'follow-us': 'Síguenos en redes sociales',
  'learn-more': 'Conoce más',
  contact: 'Contáctanos',
  blog: 'Blog',
  privacy: 'Política de Privacidad',
  terms: 'Términos y Condiciones',
  'get-involved': 'Involúcrate',
  apply: 'Postula al bootcamp',
  hire: 'Contrata talento',
  'work-with-us': 'Trabaja con nosotros/as',
  copyright: 'Todos los derechos reservados.',
};

export default es;